export default function hasFloatValidDigits(float: number, digitsCount: number, decimalDigitsCount: number): boolean {
	const regexp =
		decimalDigitsCount > 0
			? new RegExp(`^\\d{1,${digitsCount}}(\\.\\d{1,${decimalDigitsCount}})?$`)
			: new RegExp(`^\\d{1,${digitsCount}}$`);

	return regexp.test(String(Math.abs(float)));
}
